import * as React from "react";
const SvgShared = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	"data-name": "Layer 1",
	viewBox: "0 0 66.43 35.29",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M66.31 32.7a3.16 3.16 0 0 1-1.4 1.4 6.6 6.6 0 0 1-2 .6 23.6 23.6 0 0 1-4.6.2H42.04a5 5 0 0 0 .83-5.16c-.55-1.64-4.46-5.44-7-7.5a23.94 23.94 0 0 1 21.65.06 21 21 0 0 1 6.7 5.2c.2.2.3.4.4.5a10.7 10.7 0 0 1 1.58 2.71 3.25 3.25 0 0 1 .11 1.99" }), /* @__PURE__ */ React.createElement("circle", {
	cx: 46.81,
	cy: 9.1,
	r: 9.1
}), /* @__PURE__ */ React.createElement("path", { d: "M39.22 33.05a3.16 3.16 0 0 1-1.4 1.4 6.6 6.6 0 0 1-2 .6 23.6 23.6 0 0 1-4.6.2h-23a23.6 23.6 0 0 1-4.6-.2 7.6 7.6 0 0 1-2-.6 3.16 3.16 0 0 1-1.4-1.4 3 3 0 0 1 0-2.3 9.5 9.5 0 0 1 1.4-2.4 2.2 2.2 0 0 1 .4-.5c3.4-4.2 9-6.9 14.3-7.6a23.7 23.7 0 0 1 14.1 2.4 21 21 0 0 1 6.7 5.2c.2.2.3.4.4.5a9.8 9.8 0 0 1 1.46 2.2 3.14 3.14 0 0 1 .24 2.5" }), /* @__PURE__ */ React.createElement("circle", {
	cx: 19.72,
	cy: 9.45,
	r: 9.1
}));
export default SvgShared;
